import React from 'react'
// import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import { Button } from 'reactstrap'
import { Modal } from 'antd';

import { If, Else, Then, Switch, Case, Default } from 'react-if'
import { FaFileDownload, FaPaperPlane, FaStop } from "react-icons/fa";
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import cookies from 'js-cookie'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import LeaveOfYear from '../LeaveOfYear/LeaveOfYearModal'
import TableApproval from '../TableApproval'
import ErrorSwal from '../SwalError'

import { downloadFilesAPI } from '../functions/LeaveRequestPage'
import { CancelLeaveReqAPI, SendLeaveReqAPI } from '../../components/functions/LeaveListPage';


const LeaveDetail = ({ isOpen, isModalVisible, values, Approvals, isDesktopSize }) => {

    const MySwal = withReactContent(Swal)
    const { t } = useTranslation()
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const history = useHistory()
    const [error, setError] = React.useState(null)
    // console.log(isDesktopSize)
    if (!isOpen) {
        return null;
    }

    const handleAttachedFile = (fileName) => {

        downloadFilesAPI(fileName)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
            })
            .catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
    }

    const handleClickSend = (LeaveNo) => {

        SendLeaveReqAPI(LeaveNo)
            .then((response) => {
                ErrorSwal({
                    title: 'Success',
                    text: response.data.message,
                    icon: 'success'
                })
                history.go(0)
            })
            .catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
        isModalVisible(false)
    }

    const cancelLeaveReq = (LeaveNo) => {
        CancelLeaveReqAPI(LeaveNo)
            .then((response) => {
                ErrorSwal({
                    title: 'Success',
                    text: response.data.message,
                    icon: 'success'
                })

            })
            .catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
        isModalVisible(false)
        history.go(0)
    }
    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    // const handleCancel = () => {
    //     isModalVisible(!isModalVisible)
    // };

    return (
        <>

            <Modal
                title={t("t_leave_dtl")}
                centered
                bodyStyle={{
                    backgroundColor: '#f2f7ff',
                }}
                open={isOpen}
                footer={null}
                onCancel={() => { isModalVisible(!isModalVisible) }}
                width={800}
            >
                <div className="content">
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-xl-6 col-lg-6">
                            <div className="portlet light bordered">
                                <div className="row">

                                    <div className="col-sm-12 col-md-12 col-xl-12 col-lg-12">
                                        <div className="card-content">
                                            <div className="card-body">
                                                <If condition={isDesktopSize}>

                                                    <Then>
                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_leave_type")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <label className="font-blue-dark" style={{ float: 'right' }}>
                                                                    <b>
                                                                        <Switch>
                                                                            <Case condition={currentLanguageCode === 'en'}> {values.leaveTypes.TYPENM} </Case>
                                                                            <Case condition={currentLanguageCode === 'th'}> {values.leaveTypes.TYPENM2} </Case>
                                                                            <Case condition={currentLanguageCode === 'jp'}> {values.leaveTypes.TYPENM3} </Case>
                                                                            <Default> {values.leaveTypes.TYPENM} </Default>
                                                                        </Switch>
                                                                    </b>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_reason")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <label className="font-blue-dark label-wrap-mobile" style={{ float: 'right' }}><b> {values.Reason}</b></label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}>{t("t_status")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <Switch>
                                                                    <Case condition={values.Status === "-3"}>
                                                                        <span className="badge bg-info" style={{ color: '#fff', float: 'right' }}> {t("t_st_drf")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "0"}>
                                                                        <span className="badge bg-warning" style={{ color: '#fff', float: 'right' }}> {t("t_st_ped")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "1"}>
                                                                        <span className="badge bg-success" style={{ color: '#fff', float: 'right' }}> {t("t_st_app")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "-1"}>
                                                                        <span className="badge bg-danger" style={{ color: '#fff', float: 'right' }}> {t("t_st_can")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "-2"}>
                                                                        <span className="badge bg-danger" style={{ color: '#fff', float: 'right' }}> {t("t_st_rej")} </span>
                                                                    </Case>
                                                                </Switch>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_leave_day")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <label className="font-blue-dark" style={{ float: 'right' }}><b> {values.Amount} {t("t_day")} </b></label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_leave_time")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <label className="font-blue-dark" style={{ float: 'right' }}><b> {values.Time}</b></label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_date_from")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <label className="font-blue-dark" style={{ float: 'right' }}><b> {values.ToDate} {values.ToTime}</b></label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_date_to")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <label className="font-blue-dark" style={{ float: 'right' }}><b> {values.EndDate} {values.EndTime}</b></label>
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_att_file")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '-22px' }}>
                                                                <If condition={values.fileName !== null && values.fileName !== ''}>
                                                                    <Then>
                                                                        <Button color="success" outline onClick={() => handleAttachedFile(values.fileName)}> <FaFileDownload /></Button>
                                                                    </Then>
                                                                    <Else>
                                                                        <label className="font-blue-dark" style={{ float: 'right' }}>
                                                                            {t("t_no_file")}
                                                                        </label>
                                                                    </Else>
                                                                </If>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_app_rmk")} :</label>
                                                            <div className="col-md-6 col-sm-8" style={{ marginTop: '0px' }}>
                                                                <label className="font-blue-dark label-wrap-mobile" style={{ float: 'left' }}><b> {values.ApproveRemark} </b></label>
                                                            </div>
                                                        </div>
                                                    </Then>

                                                    <Else>
                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_leave_type")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <label className="font-blue-dark">
                                                                    <b>
                                                                        <Switch>
                                                                            <Case condition={currentLanguageCode === 'en'}> {values.leaveTypes.TYPENM} </Case>
                                                                            <Case condition={currentLanguageCode === 'th'}> {values.leaveTypes.TYPENM2} </Case>
                                                                            <Case condition={currentLanguageCode === 'jp'}> {values.leaveTypes.TYPENM3} </Case>
                                                                            <Default> {values.leaveTypes.TYPENM} </Default>
                                                                        </Switch>
                                                                    </b>
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_reason")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <label className="font-blue-dark label-wrap-desktop"><b> {values.Reason}</b></label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}>{t("t_status")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <Switch>
                                                                    <Case condition={values.Status === "-3"}>
                                                                        <span className="badge bg-info" style={{ color: '#fff' }}> {t("t_st_drf")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "0"}>
                                                                        <span className="badge bg-warning" style={{ color: '#fff' }}> {t("t_st_ped")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "1"}>
                                                                        <span className="badge bg-success" style={{ color: '#fff' }}> {t("t_st_app")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "-1"}>
                                                                        <span className="badge bg-danger" style={{ color: '#fff' }}> {t("t_st_can")} </span>
                                                                    </Case>
                                                                    <Case condition={values.Status === "-2"}>
                                                                        <span className="badge bg-danger" style={{ color: '#fff' }}> {t("t_st_rej")} </span>
                                                                    </Case>
                                                                </Switch>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_leave_day")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <label className="font-blue-dark"><b> {values.Amount} {t("t_day")} </b></label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_leave_time")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <label className="font-blue-dark"><b> {values.Time}</b></label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_date_from")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <label className="font-blue-dark"><b> {values.ToDate} {values.ToTime}</b></label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_date_to")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <label className="font-blue-dark"><b> {values.EndDate} {values.EndTime}</b></label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_att_file")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <If condition={values.fileName !== null && values.fileName !== ''}>
                                                                    <Then>
                                                                        <Button color="success" outline onClick={() => handleAttachedFile(values.fileName)}> <FaFileDownload /></Button>
                                                                    </Then>
                                                                    <Else>
                                                                        <label className="font-blue-dark">
                                                                            {t("t_no_file")}
                                                                        </label>
                                                                    </Else>
                                                                </If>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 row">
                                                            <label className="col-md-6 col-sm-4" style={{ textAlign: '' }}> {t("t_app_rmk")} :</label>
                                                            <div className="col-md-6 col-sm-8">
                                                                <label className="font-blue-dark label-wrap-desktop"><b> {values.ApproveRemark}</b></label>
                                                            </div>
                                                        </div>
                                                    </Else>
                                                </If>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="gap-2 mt-3 d-grid d-md-flex justify-content-md-end">
                                    <If condition={values.Status === "-3"}>
                                        <Then>
                                            <Button className="ml-2" color="primary" outline
                                                onClick={async () => handleClickSend(values.LeaveID)}>
                                                <FaPaperPlane />  {t("b_send")}
                                            </Button>
                                        </Then>
                                    </If>
                                    <If condition={values.Status === "0" || values.Status === "-3"}>
                                        <Then>
                                            <Button className="ml-2" color="danger" outline
                                                onClick={async () => {
                                                    MySwal.fire({
                                                        title: `${t("t_title_cancel")}`,
                                                        text: `${t("t_text_cancel")}`,
                                                        icon: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonColor: '#3085d6',
                                                        cancelButtonColor: '#d33',
                                                        confirmButtonText: `${t("b_md_cancel_confirm")}`,
                                                        cancelButtonText: `${t("b_md_cancel_cancel")}`

                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            cancelLeaveReq(values.LeaveID)
                                                            MySwal.fire(
                                                                `${t("t_title_canceled")}`,
                                                                `${t("t_text_canceled")}`,
                                                                'success'
                                                            )
                                                        }
                                                    })
                                                }}
                                            >
                                                <FaStop />  {t("b_cancel")}
                                            </Button>
                                        </Then>
                                    </If>
                                    {/* Export pdf  */}
                                    {/* <Button className="ml-2" outline
                                            onClick={() => history.push('/pdf/' + values.LeaveID)}
                                        >
                                            {t("b_ex_pdf")}
                                        </Button> */}
                                    {/* Export pdf  */}
                                </div>

                            </div>
                            <If condition={values.Status !== "-3" && values.Status !== "-1"}>
                                <Then>
                                    <div className="portlet light bordered">

                                        <TableApproval ApproveLists={Approvals} />

                                    </div>
                                </Then>
                            </If>

                        </div>
                        <div className="col-sm-12 col-md-6 col-xl-6 col-lg-6">
                            <div className="portlet light bordered">
                                <LeaveOfYear EmpNO={values.EmpNo} />
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        </>
    )
}

export default LeaveDetail